import script from "./MGSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGSelect.vue?vue&type=script&setup=true&lang=ts"

import "./MGSelect.vue?vue&type=style&index=0&id=2075ce5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2075ce5f"]])

export default __exports__